import React from "react";
import "./UpdateHistory.css";
import Image from "../../images/user.svg";
import { firestoreConnect } from "react-redux-firebase";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link } from "react-router-dom";
import InfoContainer from "../../components/layout/UpdateHistory/InfoContainer";

const PlayerUpdateInfo = (props) => {
  return (
    <div className="testimonial update-profile">
      <div className="testimonialbar"></div>
      {props.data && Object.keys(props.data).length > 0 && (
        <div className="AboutContainer">
          <h1>Player Update Info</h1>
          <div class="AthleteDetailsThumbnailContainer">
            <img
              src={
                props.data?.thumbnail === "None" ? Image : props.data?.thumbnail
              }
              alt={Image}
            />
          </div>
          <div class="athlet-name">
            <Link to={`/super-admin/${props.data?.id}`}>
              <h3>{props.data?.name}</h3>
            </Link>
          </div>
          <InfoContainer data={props.data} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps?.match?.params?.id;
  let updateData = {};
  let data = {};
  updateData = state.firestore.data.updateReport;
  if (id && updateData && Object.keys(updateData).length > 0) {
    if (updateData[id] && Object.keys(updateData[id]).length > 0) {
      data = updateData[id];
      data = {
        ...data,
        thumbnail: data?.new?.thumbnail
          ? data?.new?.thumbnail
          : data?.old?.thumbnail,
        name: data?.old?.firstName + " " + data?.old?.lastName,
      };
      const oldData = data.old;
      let newData = {};
      let uncommonOldData = {};
      let uncommonNewData = {};

      if (data.new && Object.keys(data.new).length > 0) {
        newData = data.new;

        Object.keys(newData).forEach((key) => {
          if (newData[key] !== oldData[key]) {
            uncommonOldData[key] = oldData[key];
            uncommonNewData[key] = newData[key];
          }
        });
      }

      data = {
        ...data,
        uncommonOldData,
        uncommonNewData,
      };
    }
  }
  return {
    data,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "updateReport",
      },
      {
        collection: "mediaOrder",
      },
    ];
    return firestoreArray;
  })
)(PlayerUpdateInfo);
